
import React, { useState, useRef, useEffect } from 'react';
import { Box, Text, Button, Image } from '@chakra-ui/react';
import BrightcovePlayer from "@brightcove/react-player-loader";
import { FaPlay } from 'react-icons/fa6';
import appConfig from '../Config/appConfig';
import '../Styles/Components/VideoComponent.css';

const VideoComponent = ({ videoId, duration, ariaLabel, thumbnail }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const playerRef = useRef(null);

  const handlePlayClick = () => {
    setIsPlaying(true);
    if (playerRef.current && playerRef.current.player) {
      playerRef.current.player.play();
    }
  };

  useEffect(() => {
    const player = playerRef.current && playerRef.current.player;
    if (player) {
      const handleEnded = () => {
        if (player.isFullscreen()) {
          player.exitFullscreen();
        }
      };
      player.on('ended', handleEnded);
      return () => {
        player.off('ended', handleEnded);
      };
    }
  }, []);

  return (
    <Box
      width="100%"
      textAlign="center"
      aria-label={ariaLabel}
      role="region"
      mb={4}
    >
      <Box
        position="relative"
        border="1px solid var(--color-dusky-teal-200, #A5AEAE)"
        mb={4}
        style={{
          maxWidth: '540px',
          margin: "0 auto",
          aspectRatio: '16 / 9',
          border: '0px'
        }}
      >
        {thumbnail && !isPlaying && (
          <>
            <Image
              src={`${appConfig.ImageBlobBaseUrl}/${thumbnail}`}
              alt="Video thumbnail"
              width="100%"
              height="100%"
              objectFit="fill"
              position="absolute"
              top="0"
              left="0"
              zIndex="2"
              borderRadius="12px"
              border="1px solid var(--color-dusky-teal-200, #A5AEAE)"
            />
            <Box
              position="absolute"
              top="100%"
              left="50%"
              transform="translate(-50%, -50%)"
              borderRadius="50%"
              width="62px"
              height="62px"
              bg="linear-gradient(180deg, #A12EFF 0%, #5F1B93 100%)"
              padding="2px"
              zIndex="3"
              boxShadow="0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
            >
              <Button
                onClick={handlePlayClick}
                width="100%"
                height="100%"
                borderRadius="50%"
                bg="white"
                color="var(--sutter-sync-purple, #5F1B93)"
                border="none"
                _hover={{
                  bg: "white",
                  color: "#A12EFF"
                }}
                _focus={{
                  bg: "var(--sutter-sync-purple, #5F1B93)",
                  color: "white"
                }}
                aria-label={ariaLabel}
                tabIndex={0}
                display="flex" 
                justifyContent="center"
                alignItems="center"
              >
                <Box ml={1}><FaPlay size={24}/></Box>
              </Button>
            </Box>
          </>
        )}

        <BrightcovePlayer
          ref={playerRef}
          accountId="817826402001"
          videoId={videoId}
          playerId="tdXIUgbsP"
          embedOptions={{ responsive: true, autoplay: false }}
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}
        />
      </Box>

      <Box width="100%" textAlign="left" mb={2}>
        <Text
          fontSize="sm"
          color="var(--color-dusky-teal, #4C5D5C)"
          aria-label={`Video duration: ${duration}`}
          mt={2}
        >
          {duration}
        </Text>
      </Box>
    </Box>
  );
};

export default VideoComponent;